(ns minorodata.webforms.model
  (:require [mold.core :as m :include-macros true]))

(declare ->webform-table-screen)

(m/defmodel webform
  {:id            [::m/string ::m/identity "Webform ID"]
   :tablename     [::m/string "Table name"]
   :row-count     [::m/number "Total number of entries in a table"]
   :username      [::m/string "Who created the webform"]
   :created-at    [::m/string "Created at timestamp"]
   :last-modified [::m/string "Last modified timestamp"]})


(m/defmodel webform-table
  {:tablename    [::m/string ::m/identity "Table name"]
   :display-name [::m/string "Display name"]
   :schema       [::m/string "Schema"]})


(m/defmodel webform-list
  {:tables          {::m/type         ::m/ref
                     ::m/cardinality  ::m/many
                     ::m/is-component ::m/component
                     ::m/ref-type     webform-table
                     ::m/doc          "Available tables"}

   :new-table-error [::m/string ::m/nilable "Possible error encountered when creating a table"]

   :webforms        {::m/type         ::m/ref
                     ::m/cardinality  ::m/many
                     ::m/is-component ::m/component
                     ::m/ref-type     webform
                     ::m/doc          "List of webforms"}}
  {:singleton true})


(m/defmodel webform-table-screen
  {:table-name     [::m/string ::m/identity]
   :columns        [::m/vector]
   :data           [::m/vector]
   :filter-field   [::m/string ::m/nilable]
   :filter-type    [::m/string ::m/nilable]
   :filter-value   [::m/string ::m/nilable]
   :order-by       [::m/string ::m/nilable]
   :order-dir      [::m/string ::m/nilable]
   :total-pages    [::m/number]
   :page           [::m/number]
   :items-total    [::m/number]
   :items-per-page [::m/number]}
  {:singleton true})
